import api from './api';

export const login = async (username, password) => {
  const response = await api.post('/auth/login', { username, password });
  const { token, user } = response.data;
  localStorage.setItem('ecoreno_token', token);
  localStorage.setItem('ecoreno_user', JSON.stringify(user));
  return { token, user };
};

export const logout = () => {
  localStorage.removeItem('ecoreno_token');
  localStorage.removeItem('ecoreno_user');
};

export const getToken = () => localStorage.getItem('ecoreno_token');

export const getUser = () => {
  const user = localStorage.getItem('ecoreno_user');
  return user ? JSON.parse(user) : null;
};

export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};
